import { createFileRoute } from '@tanstack/react-router'

import { AppSidebarContainer } from '@/components/app/app-sidebar-container'
import { OrderMatchingNavigation } from '@/components/screens/order-line-matching/navigation'
import { OrderUnlinkedContainer } from '@/components/screens/order-line-matching-p2/unlinked-container'
import { ErrorPanel } from '@/components/ui/error-panel'
import { useMe } from '@/providers/me-context'

export const Route = createFileRoute('/t/$tenant_id/order_line_matching/unlinked')({ component: Page })
function Page() {
  const { tenant_id: tenantId } = Route.useParams()
  const me = useMe()
  return (
    <div className="flex min-h-screen bg-background">
      <AppSidebarContainer tenantId={tenantId} />
      <main className="min-w-0 flex-1 space-y-4 p-6">
        {me.tenant.setting?.orderLineMatchingEnabled === true && (
          <OrderMatchingNavigation tenantId={tenantId} value="unlinked" />
        )}
        {me.tenant.setting?.orderLineMatchingEnabled === true ? (
          <OrderUnlinkedContainer
            canEdit
            tenantId={tenantId}
            millsheetSortConfig={me.tenant.setting.millsheetSortConfig ?? {}}
            key={tenantId}
          />
        ) : (
          <ErrorPanel
            layout="section"
            title="発注明細照合を利用できません"
            description="テナントの機能設定を確認してください。"
          />
        )}
      </main>
    </div>
  )
}
